<template>
    <b-button class="inline-submenu-btn with_icon" @click="is_in_favorites ? removeFromFavorite() : addToFavorite()">
        <b-icon v-if="!is_in_favorites" icon="star" aria-hidden="true"></b-icon>
        <b-icon v-else icon="star-fill" aria-hidden="true"></b-icon>
        <span v-if="!is_in_favorites">Ajouter aux favoris</span>
        <span v-else>Retirer des favoris</span>
    </b-button>

</template>

<script>
export default {
    props: ["id_coureur"],
    data() {
        return {
            favoris: [],
        }
    },
    computed: {
        is_in_favorites() {
            if (!this.id_coureur) return false;

            return this.favoris.includes(parseInt(this.id_coureur));
        },
    },
    methods: {
        addToFavorite() {

            if (!this.favoris.includes(this.id_coureur)) {
                this.favoris.push(parseInt(this.id_coureur));
            }
            this.$cookies.set("favorites_" + this.$store.state.module.base, this.favoris);
            this.loadFavoris();

        },
        removeFromFavorite() {

            const index = this.favoris.indexOf(parseInt(this.id_coureur));
            this.favoris.splice(index, 1);
            this.$cookies.set("favorites_" + this.$store.state.module.base, this.favoris);
            this.loadFavoris();

        },
        loadFavoris() {
            let key = "favorites_" + this.$store.state.module.base;

            if (this.$cookies.isKey(key)) {
                let favs = this.$cookies.get(key);
                if (favs) {
                    this.favoris = favs.split(",").map(id => parseInt(id));
                } else {
                    this.$cookies.set(key, []);
                }
            } else {
                this.$cookies.set(key, []);
            }

        },
    },
    created() {
        this.loadFavoris();
    },
}
</script>

<style lang="scss" scoped></style>